<template>
  <v-card flat color="transparent">
    <v-container fluid class="pa-0 ma-0">
      <v-row no-gutters justify="end" align="center">
        <v-col cols="6" v-if="mostrarBotonAnular" class="pr-1">
          <icon-button
            icon="bxs-folder-minus"
            color="error"
            @click="onClickAnular"
          >
            {{ $t("pesajes.tabla.boton-anular.tooltip") }}
          </icon-button>
        </v-col>
        <v-col cols="6" class="pl-1">
          <icon-button
            :icon="
              isSelected ? 'fas-circle-xmark' : 'ionic-md-information-circle'
            "
            :color="isSelected ? 'error' : 'primary'"
            @click="onClickInformacion"
          >
            {{
              $t(
                `pesajes.tabla.boton-informacion.${
                  isSelected ? "cerrar" : "tooltip"
                }`
              )
            }}
          </icon-button>
        </v-col>
      </v-row>
    </v-container>
  </v-card>
</template>

<script lang="ts">
// decoradores
import { Component, Emit, Prop, Vue } from "vue-property-decorator";
// tipos
import { Item } from "@/typings/components/pesajes/tabla";
import { Pesaje } from "@/typings/store/plugins/easyFirestore/pesajes";
// componentes
import IconButton from "@/components/custom/IconButton.vue";

@Component({
  components: {
    IconButton,
  },
})
export default class OpcionesTabla extends Vue {
  @Prop() readonly item!: Item;
  @Prop() readonly mostrarBotonAnular!: boolean;
  @Prop() readonly seleccionado!: Pesaje | null;

  get isSelected(): boolean {
    return (
      this.seleccionado !== null && this.seleccionado.id === this.item.pesaje.id
    );
  }

  @Emit("click:informacion")
  onClickInformacion(): Item {
    return this.item;
  }

  @Emit("click:anular")
  onClickAnular(): Item {
    return this.item;
  }
}
</script>
